export * from './src/restaurants-v1-availability-exception-availability-exceptions.universal.js';
